import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChecklistItem, ExecutionItem } from '../../interfaces/changeRequest';
interface ChangeRequestEditState {
  isExpanded: boolean;
  editingItem: ChecklistItem | ExecutionItem | null;
}

const initialState: ChangeRequestEditState = {
  isExpanded: false,
  editingItem: null,
};

const changeRequestEditSlice = createSlice({
  name: 'changeRequestEdit',
  initialState,
  reducers: {
    resetChangeRequestEdit: () => {
      return initialState;
    },
    setCREditingDialogExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
    setChangeRequestEditingItem: (
      state,
      action: PayloadAction<ChecklistItem | ExecutionItem | null>
    ) => {
      state.editingItem = action.payload;
    },
  },
});

export const {
  resetChangeRequestEdit,
  setCREditingDialogExpanded,
  setChangeRequestEditingItem,
} = changeRequestEditSlice.actions;
export default changeRequestEditSlice.reducer;
